import zxcvbn from 'zxcvbn';

const minLengthRegex = /^.{12,}$/;
// eslint-disable-next-line no-useless-escape
const uppercaseAndSpecialCharRegex = /(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])/;

export default {
  minLength: minLengthRegex,
  uppercaseAndSpecialChar: uppercaseAndSpecialCharRegex,
  isStrong: (password = '') => minLengthRegex.test(password) && uppercaseAndSpecialCharRegex.test(password) && zxcvbn(password)?.score > 1,
};
